import StockTakeProductListTable from './stockTakeProductListTable.container';

export default StockTakeProductListTable